import {Fragment, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import DotsLoading from '../../../../components/dotsLoading';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetCardNumber from '../../../../services/hookService/getCardNumber/useGetCardNumber';
import useGetInstallmentPrice from '../../../../services/hookService/getInstallmentPrice/useGetInstallmentPrice';
import usePostInstallmentCardToCardPayment from '../../../../services/hookService/postInstallmentCardToCardPayment/usePostInstallmentCardToCardPayment';
import convertNumberToPersianExactUnits from '../../../../utilities/helper/unitConvertor/convertNumberToPersianExactUnits';
import CardNumberItem from '../../../shopping-basket/cash-payment/card-to-card-pay/CardNumberItem';
import ReceiptImageUpload from '../../../shopping-basket/cash-payment/card-to-card-pay/ReceiptImageUpload';

interface IState {
  loanGuid: string;
}

const InstallmentCardToCardGatewayPage = () => {
  const navigate = useNavigate();

  const {state} = useLocation();

  const {loanGuid} = state as IState;

  const [uploadedImage, setUploadedImage] = useState<File | null>(null);
  const {data, cadNumberIsLoading} = useGetCardNumber('ملی');

  const {data: installmentPrice, isLoading: isInstallmentPriceLoading} =
    useGetInstallmentPrice(loanGuid);

  const {mutate, isLoading: isPostCardToCardLoading} =
    usePostInstallmentCardToCardPayment({
      onSuccess: () => {
        navigate('/installment-card-to-card-pay/pending', {
          replace: true,
        });
      },
    });

  const isLoading = cadNumberIsLoading || isInstallmentPriceLoading;

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">پرداخت</span>
          </div>
        )}
      />

      {/* Page Content */}
      <div className="flex flex-col w-full h-full gap-3 p-6 overflow-y-auto">
        <span className="text-sm font-medium text-neutral-600">
          پرداخت کارت به کارت
        </span>

        <p className="pb-0 mb-0 text-sm text-zinc-800">
          مبلغ{' '}
          {convertNumberToPersianExactUnits(
            installmentPrice?.payment_price ?? 0,
          )}{' '}
          را به یکی از شماره کارت‌های زیر انتقال دهید سپس تصویر رسید را ارسال
          کنید.
        </p>

        {isLoading && <DotsLoading />}

        <div className="mb-4 space-y-2">
          {data?.map((cardNum: ICardNumber, index) => (
            <Fragment key={index}>
              <CardNumberItem
                logo={cardNum.bank_logo || ''}
                cardNumber={cardNum.card_number}
                cardShabaNumber={cardNum.shaba_number || ''}
              />
            </Fragment>
          ))}
        </div>

        <ReceiptImageUpload
          setUploadedImage={setUploadedImage}
          uploadedImage={uploadedImage}
        />
      </div>

      {/* Page Action Button */}
      <div className=" w-full px-4  flex  bg-white shadow-[0px_-1px_6px_0px_rgba(0,_0,_0,_0.1)]">
        <button
          type="button"
          className="flex items-center justify-center w-full h-12 mb-4 text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700 text-md"
          disabled={Boolean(!uploadedImage || !loanGuid)}
          onClick={() => mutate({taken_loan: loanGuid, image: uploadedImage})}
        >
          {isLoading || isPostCardToCardLoading ? (
            <SpinnerLoading size={14} />
          ) : (
            'تایید'
          )}
        </button>
      </div>
    </div>
  );
};

export default InstallmentCardToCardGatewayPage;
